import { Button as e } from "../Button/Button.js";
import t from "./Calendar.module.js";
import { jsxDEV as n } from "react/jsx-dev-runtime";
//#region lib/components/DatePicker/CalendarFooter.tsx
var r = "/opt/render/project/src/shared-ui/lib/components/DatePicker/CalendarFooter.tsx";
function i({ onCancel: i, onApply: a, applyDisabled: o }) {
	return /* @__PURE__ */ n("div", {
		className: t.footer,
		children: [/* @__PURE__ */ n(e, {
			className: t.footerButton,
			color: "neutral",
			size: "lg",
			onClick: i,
			children: "Cancel"
		}, void 0, !1, {
			fileName: r,
			lineNumber: 13,
			columnNumber: 13
		}, this), /* @__PURE__ */ n(e, {
			className: t.footerButton,
			color: "primary",
			size: "lg",
			disabled: o,
			onClick: a,
			children: "Apply"
		}, void 0, !1, {
			fileName: r,
			lineNumber: 16,
			columnNumber: 13
		}, this)]
	}, void 0, !0, {
		fileName: r,
		lineNumber: 12,
		columnNumber: 9
	}, this);
}
//#endregion
export { i as CalendarFooter };
